import { authTimeout } from '~/redux/application';
import { store } from '~/index.js';
import { config } from '../config';
import { ErrorCode } from '../constants';

export const handleErrors = (response) => {
    // If the status is a 401, our token in no longer valid and the user needs to log back in.
    if (response.status === 401 && store) store.dispatch(authTimeout());
    if (!response.ok || response.status !== 200) {
        const error = new Error(response.statusText);
        error.code = response.status;
        throw error;
    }
    return response;
}

export const getError = data => data && (data.status === -1 || data.Status === -1) ? (`${data.msg || data.Msg || 'error occurred'}${config.isDebug && (data.errorCode || data.ErrorCode) ? `(${data.errorCode || data.ErrorCode || ''})` : ''}`) : data && data instanceof Error ? (data.message) : typeof data === 'string' ? data : '';

export const handleProfileTokenExpired = (data) => {
    if (!data || !store) return false;
    const timeoutMsg = data.msg || data.Msg;
    const timeoutCode = data.errorCode || data.ErrorCode;
    if ([ErrorCode.TokenExpired, ErrorCode.LoginTimeout, ErrorCode.KillLogin].includes(timeoutCode)) {
        store.dispatch(authTimeout({ code: timeoutCode, msg: timeoutCode == ErrorCode.KillLogin ? timeoutMsg : undefined }));
        return true;
    }
    return false;
}

export const handleCheckSession = () => {
    const auth = store.getState().application.auth;
    if (auth && auth.isAuthenticated() && auth.isNeedCheckSession()) {
        return auth.renewToken();
    }
    return Promise.resolve();
}
